export default __webpack_public_path__ + "static/media/Icon=Doctor Ranks.dd3f1d71.svg";